import {Mapper} from '@s-ui/domain'

export default class FromSearchUrlParamToSearchCodeValueObjectMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  _parseSearchUrlParam = ({searchUrlParam} = {}) => searchUrlParam?.replace(/_/g, ' ').toUpperCase()

  map = ({searchUrlParam}) => {
    const searchCode = this._parseSearchUrlParam({searchUrlParam})
    return this._valueObject({searchCode})
  }
}
